module.exports = __webpack_public_path__ + "img/bell_thumbnail.2c7a8434.png";